import { MsrcThemeProvider, styled } from '@migros/msrc-ui-kit';
import React from 'react';
import { RatingSize } from '../../../components/rating';
import { RatingsSummary } from '../../../components/ratings-summary';
import { useI18n } from '../../../hooks/use-i18n';
import { useTrackWidgetVersion } from '../../../hooks/use-track-widget-version';
export const RatingsSummaryWidget = ({
  theme,
  rating,
  showAverageRating,
  size = RatingSize.small,
  count,
  language
}) => {
  useTrackWidgetVersion('ratings-summary');
  useI18n(language);
  return /*#__PURE__*/React.createElement(MsrcThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(RatingsSummary, {
    rating: rating,
    count: count,
    size: size,
    showAverageRating: showAverageRating
  })));
};
const Root = styled.div`
  font-size: ${({
  theme: {
    fonts
  }
}) => fonts.sizes.text.small};
`;